import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=740e6259&scoped=true&"
import script from "./DoctorInfo.vue?vue&type=script&lang=js&"
export * from "./DoctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./DoctorInfo.vue?vue&type=style&index=0&id=740e6259&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e6259",
  null
  
)

export default component.exports